export const EXPIRATION = [
  {
    label: 'GTC',
    value: 0
  },
  {
    label: 'Today',
    value: 1
  },
  {
    label: 'Specified',
    value: 2
  },
  {
    label: 'Specified Day',
    value: 3
  }
];
